'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PortalIdParser from 'PortalIdParser';
import ReactDom from 'react-dom';
import I18n from 'I18n';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import 'I18n/init/data/allTimezones';
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
import userInfo from 'hub-http/userInfo';
import { Provider } from 'react-redux';
import Raven from 'raven-js';
import Actions from 'AdsUI/lib/Actions';
import { Router } from 'react-router-dom';
import routes from 'AdsUI/lib/Routes';
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';
import { createBrowserHistory } from 'history'; // Required to kick off Redux

import store from 'AdsUI/redux-store';
import Gates from 'AdsUI/lib/Gates'; // Laboratory copy experiments

import createExperimentI18nProvider from 'laboratory-lib/i18n/createExperimentI18nProvider';
import experimentalLang from 'i2l?query=sporks!../lang/laboratory-copy-experiments/en.lyaml';
import { treatmentsClient } from 'AdsUI/lib/ExperimentApi';
export default class App {
  start() {
    // Need to make sure portalId is available, which will occur as a side-effect
    // of calling PortalIdParser.get(), which will attempt to get the portalId
    // from the URL, then fallback to the cookie/legacy access token.
    PortalIdParser.get();
    this.init().catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }

  init() {
    const StandardI18nProvider = createStandardI18nProvider();
    const ExperimentalI18nProvider = createExperimentI18nProvider({
      client: treatmentsClient
    });
    const I18nProviders = [[StandardI18nProvider, lang], [ExperimentalI18nProvider, experimentalLang]];
    const I18nRegistrations = I18nProviders.map(([provider, langFile]) => provider.register(langFile));
    const langAvailable = initAppTranslations([...I18nRegistrations, registerAllData(StandardI18nProvider)]);
    return Promise.all([this.auth()]).then(([authConfig]) => {
      if (authConfig) {
        I18nProviders.forEach(([I18nProvider]) => {
          I18nProvider.setLocale({
            locale: authConfig.user.locale,
            langEnabled: authConfig.user.lang_enabled,
            timezone: authConfig.portal.timezone
          });
        });
      }

      return langAvailable.then(this.startReduxAndRouter);
    });
  }

  startReduxAndRouter() {
    const history = createBrowserHistory({
      basename: `ads/${PortalIdParser.get()}`
    });
    ReactDom.render( /*#__PURE__*/_jsx(RhumbProvider, {
      config: rhumbConfig,
      history: historyAdapter(history),
      children: /*#__PURE__*/_jsx(Provider, {
        store: store,
        children: /*#__PURE__*/_jsx(Router, {
          history: history,
          children: routes
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

  auth() {
    return userInfo().then(({
      portal,
      gates,
      user
    }) => {
      store.dispatch({
        type: Actions.AUTH_FETCH,
        payload: {
          user,
          gates,
          portal
        }
      }); //  https://git.hubteam.com/HubSpot/I18n/blob/94d32c3abc1a342b9ef21d4c4e37e986a0f90dba/docs/errors.md#sentries

      I18n.sendSentryOnMissingTranslations = true;
      I18n.sendSentryOnMissingValues = true;
      Gates.setGatesThatAreUngated(gates);
      Raven.setUserContext({
        id: user.user_id,
        email: user.email,
        locale: user.locale
      });
      return {
        portal,
        gates,
        user
      };
    }).catch(error => {
      if (error.message !== 'Aborting: redirection in progress') {
        throw error;
      }
    });
  }

}